module.exports = __webpack_public_path__ + "images/19738d136e0b0da128e255a83f1b3f910ab9a260e622bd557ebe1c1ad7dc8135.svg";